import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { range, find, get } from 'lodash'
import DataFilters from '../../DataFilters'
import { round } from '../../../../../helpers'
import { makeStyles } from '@material-ui/styles'
import Select from 'react-select'
import axios from 'axios'
import ProjectedAverageCostOfLaborDetailReport from './ProjectedAverageCostOfLaborDetailReport'

// Styles
const useStyles = makeStyles(theme => ({
	forecastSelectionArea: {
		width: 200,
		display: 'block',
		marginBottom: 14,
		margin: '0 auto',
		paddingBottom: 13,
	},
}))

export default function ProjectedAverageCostOfLaborDetail(props) {

	const classes = useStyles()
	const [workforceData, setWorkforceData] = useState({})
	const [applyFilter, setApplyFilter] = useState(false)

	useEffect(() => {
		if (props.selectedForecast) {
			axios.post(`/api/workforce_forecast/filters/${props.selectedForecast.value}`, props.reportFilters)
				.then((result) => {
					const categoryToDataMap = {}
					result.data.data.forEach(d => {
						if (!categoryToDataMap[d.job_grade]) {
							categoryToDataMap[d.job_grade] = { hierarchy: d.hierarchy, employeesCount: d.employees_count, estimatedSalary: d.estimated_salary_usd }
						} else {
							categoryToDataMap[d.job_grade] = { hierarchy: d.hierarchy, employeesCount: categoryToDataMap[d.job_grade].employeesCount + d.employees_count, estimatedSalary: categoryToDataMap[d.job_grade].estimatedSalary + d.estimated_salary_usd }
						}
					})
					setWorkforceData(categoryToDataMap)
				})
				.catch((error) => {
					console.log(error)
					setWorkforceData([])
				})
		}
	}, [props.selectedForecast, applyFilter])

	const onApply = (filters) => {
		props.onApply(filters, 'ProjectedAverageCostOfLaborDetail')
	}

	const groups = ['E', 'M', 'P', 'S']

	const groupsNames = {
		'E': 'Executive (E)',
		'M': 'People Mgmt (M)',
		'P': 'Professional IC (P)',
		'S': 'Support (S)',
	}

	const levelsData = []
	const groupSummary = {}
	let currentTotalN = 0

	groups.forEach(g => {
		groupSummary[g] = {
			current: { total: 0, salary: 0, average_salary: 0, percent: 0, averageCostRows: 0 },
			growth: { total: 0, salary: 0, average_salary: 0, percent: 0, averageCostRows: 0 },
			future: { total: 0, salary: 0, average_salary: 0, percent: 0, averageCostRows: 0 },
		}
	})

	range(14).forEach(level => {
		const levelData = props.masterData.jobGrades.filter(hd => hd.hierarchy === level)
		const groupData = {}
		groups.forEach(g => {
			groupData[g] = {
				level: '',
				title: '',
				current: { n: '', salary: '', average_salary: 0, percent: '' },
				growth: { n: '', salary: '', average_salary: 0, percent: '' },
				future:  { n: '', salary: '', average_salary: 0, percent: '' },
			}
		})

		levelData.forEach(ld => {
			const groupKey = ld.job_grade.slice(0, 1)
			const dataInReport = find(props.reportData, { 'compkit_job_grade': ld.job_grade })
			const dataInWorkforce = get(workforceData, ld.job_grade, null)
			groupData[groupKey].level = ld.job_grade
			groupData[groupKey].title = ld.job_title

			if (get(dataInReport, 'avg_annual_base_salary')) {
				groupSummary[groupKey].current.averageCostRows = groupSummary[groupKey].current.averageCostRows + 1
				groupSummary[groupKey].future.averageCostRows = groupSummary[groupKey].future.averageCostRows + 1
			}
			if (get(dataInWorkforce, 'estimatedSalary')) {
				groupSummary[groupKey].growth.averageCostRows = groupSummary[groupKey].growth.averageCostRows + 1
			}

			groupData[groupKey].current.n = get(dataInReport, 'total', 0)
			groupData[groupKey].current.salary = round(get(dataInReport, 'avg_annual_base_salary', 0) / (props.selectedCurrency !== null ? props.selectedCurrency.dollar_rate : 1) * groupData[groupKey].current.n)
			groupData[groupKey].current.average_salary = round(groupData[groupKey].current.salary / groupData[groupKey].current.n )

			groupData[groupKey].growth.n = get(dataInWorkforce, 'employeesCount', 0)
			groupData[groupKey].growth.salary = round(get(dataInWorkforce, 'estimatedSalary', 0) / (props.selectedCurrency !== null ? props.selectedCurrency.dollar_rate : 1))
			groupData[groupKey].growth.average_salary = round(groupData[groupKey].growth.salary / groupData[groupKey].growth.n )

			groupData[groupKey].future.n = groupData[groupKey].current.n + groupData[groupKey].growth.n
			groupData[groupKey].future.salary = groupData[groupKey].current.salary + groupData[groupKey].growth.salary
			groupData[groupKey].future.average_salary = round(groupData[groupKey].future.salary / groupData[groupKey].future.n)


			groupSummary[groupKey].current.total = round(groupSummary[groupKey].current.total + groupData[groupKey].current.n)
			groupSummary[groupKey].growth.total = round(groupSummary[groupKey].growth.total + groupData[groupKey].growth.n)
			groupSummary[groupKey].future.total = round(groupSummary[groupKey].future.total + groupData[groupKey].future.n)

			groupSummary[groupKey].current.salary = round(groupSummary[groupKey].current.salary + groupData[groupKey].current.salary)
			groupSummary[groupKey].growth.salary = round(groupSummary[groupKey].growth.salary + groupData[groupKey].growth.salary)
			groupSummary[groupKey].future.salary = round(groupSummary[groupKey].future.salary + groupData[groupKey].future.salary)

			groupSummary[groupKey].current.average_salary = round(groupSummary[groupKey].current.average_salary  + groupData[groupKey].current.average_salary)
			groupSummary[groupKey].growth.average_salary = round(groupSummary[groupKey].growth.average_salary  + groupData[groupKey].growth.average_salary)
			groupSummary[groupKey].future.average_salary = round(groupSummary[groupKey].future.average_salary  + groupData[groupKey].future.average_salary)


		})
		levelsData.push(groupData)
	})

	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.percent = round((level[group].current.n / groupSummary[group].current.total) * 100)
				level[group].growth.percent = round((level[group].growth.n / groupSummary[group].growth.total) * 100)
				level[group].future.percent = round((level[group].future.n / groupSummary[group].future.total) * 100)
				groupSummary[group].current.percent = round(groupSummary[group].current.percent + level[group].current.percent)
				groupSummary[group].growth.percent = round(groupSummary[group].growth.percent + level[group].growth.percent)
				groupSummary[group].future.percent = round(groupSummary[group].future.percent + level[group].future.percent)
			}
		})
	})

	Object.keys(groupSummary).forEach(key => {
		currentTotalN = round(currentTotalN + groupSummary[key].current.total)
		groupSummary[key].current.percent = round(groupSummary[key].current.percent, 0)
		groupSummary[key].growth.percent = round(groupSummary[key].growth.percent, 0)
		groupSummary[key].future.percent = round(groupSummary[key].future.percent, 0)
		groupSummary[key].current.average_salary = round(groupSummary[key].current.average_salary / groupSummary[key].current.averageCostRows)
		groupSummary[key].growth.average_salary = round(groupSummary[key].growth.average_salary / groupSummary[key].growth.averageCostRows)
		groupSummary[key].future.average_salary = round(groupSummary[key].future.average_salary / groupSummary[key].future.averageCostRows)
	})

	/**
	 * Below is the Display logic for Rows
	 */
	levelsData.forEach(level => {
		groups.forEach(group => {
			if (level[group].current.n !== '') {
				level[group].current.percent = level[group].current.percent.toFixed(1)
				level[group].growth.percent = level[group].growth.percent.toFixed(1)
				level[group].future.percent = level[group].future.percent.toFixed(1)
			}
		})
	})

	return (
		<>
			<DataFilters
				fetchedFilterData={props.fetchedFilterData}
				filtersData={props.filtersData}
				onDataFilterSelect={props.onDataFilterSelect}
				componentName={'ProjectedAverageCostOfLaborDetail'}
				reportFilters={props.reportFilters}
				onApply={onApply}
				resetFilter={props.resetFilter}
				reportFiltersType={props.reportFiltersType}
				reportDataChanged={props.reportDataChanged}
				setApplyFilters={setApplyFilter}
				applyFilters={applyFilter}
			/>
			<div className={classes.forecastSelectionArea}>
				<Typography display='inline'>Select Hiring Forecast</Typography>
				<Select
					value={props.selectedForecast}
					onChange={(selectedForecastOption) => props.forecastSelectionChanged('organizationProjectedDetails', selectedForecastOption)}
					options={props.forecastOptions}
				/>
			</div>
			<ProjectedAverageCostOfLaborDetailReport
				groups={groups}
				groupSummary={groupSummary}
				groupsNames={groupsNames}
				levelsData={levelsData}
				currentTotalN={currentTotalN}
				currencyCode={props.selectedCurrency !== null ? props.selectedCurrency.short_code : 'USD'}
			/>
		</>
	)
}

ProjectedAverageCostOfLaborDetail.propTypes = {
	masterData: PropTypes.object.isRequired,
	onDataFilterSelect: PropTypes.func.isRequired,
	reportFilters: PropTypes.object.isRequired,
	reportData: PropTypes.array.isRequired,
	onApply: PropTypes.func.isRequired,
	forecastOptions: PropTypes.array.isRequired,
	selectedForecast: PropTypes.object,
	forecastSelectionChanged: PropTypes.func.isRequired,
}
